import { doFetch } from './fetch';
import { fetchCsrfToken } from '../csrf-token-module.js';
import * as logger from '../datadog-logger.js';
import * as loadingMask from './load-mask.js';

/**
 * Add event listener to the coupon box to toggle the collapsed state.
 */
function toggleCouponBox() {
  const couponBox = document.querySelector('.js_coupon_box');
  if (!couponBox) {
    return;
  }

  couponBox.addEventListener('click', (event) => {
    // Only toggle when clicking the box itself or the label, not interactive elements like the input field.
    if (couponBox !== event.target && !event.target.closest('.code_label')) {
      return;
    }

    couponBox.classList.toggle('collapsed');
  });
}

function addCodeRedemptionListeners() {
  const codeField = document.getElementById('code-field');
  if (!codeField) {
    return;
  }

  codeField.addEventListener('keydown', (event) => {
    if (event.key === 'Enter') {
      applyCouponCode(codeField.value);
    }
  });

  document.getElementById('js-redeem-coupon').addEventListener('click', () => applyCouponCode(codeField.value));

  if (localStorage.getItem('couponCodeRecentlyRedeemed') === 'true') {
    createFeedbackDialog('feedback_success', 'Super, dein Gutschein wurde erfolgreich hinzugefügt.', 3000);
    localStorage.setItem('couponCodeRecentlyRedeemed', 'false');
  }

  if (localStorage.getItem('couponCodeError') && localStorage.getItem('couponCodeError') !== 'false') {
    createFeedbackDialog('feedback_error', localStorage.getItem('couponCodeError'));
    localStorage.setItem('couponCodeError', 'false');
  }
}

function applyCouponCode(code) {
  loadingMask.show();
  const formData = new FormData();
  formData.append('couponCode', code);
  doFetch(
    '/basketActionEndpoint.php?action=redeemCouponCode',
    {
      method: 'POST',
      body: formData,
      headers: {
        'X-CSRF-Token': fetchCsrfToken(),
      },
    },
    (response) => {
      if (response.success) {
        localStorage.setItem('couponCodeRecentlyRedeemed', 'true');
      } else {
        localStorage.setItem('couponCodeError', response.error);
      }
      window.location.reload();
    },
  );
}

function removeVoucher(id) {
  loadingMask.show();
  const formData = new FormData();
  formData.append('voucherId', id);
  doFetch(
    '/basketActionEndpoint.php?action=removeVoucher',
    {
      method: 'POST',
      body: formData,
      headers: {
        'X-CSRF-Token': fetchCsrfToken(),
      },
    },
    (response) => {
      if (response.success) {
        window.location.reload();
      } else {
        createFeedbackDialog('feedback_error', response.error);
        loadingMask.hide();
      }
    },
  );
}

function addRemoveCouponsListener() {
  document.querySelectorAll('.js_remove_coupon').forEach((element) =>
    element.addEventListener('click', () =>
      fetch('/shopController.php?objective=removeCouponCodes', {
        method: 'POST',
        headers: {
          'X-CSRF-Token': fetchCsrfToken(),
        },
      })
        .then(() => window.location.reload())
        .catch(logger.logError),
    ),
  );
}

function addVoucherListeners() {
  document.addEventListener('click', (event) => {
    const removeVoucherElement = event.target.closest('.js_remove_voucher');
    if (removeVoucherElement) {
      removeVoucher(removeVoucherElement.dataset.id);
      return;
    }

    const voucherElement = event.target.closest('.js_voucher');
    if (voucherElement) {
      if (voucherElement.classList.contains('active')) {
        removeVoucher(voucherElement.dataset.id);
      } else {
        applyCouponCode(voucherElement.dataset.code);
      }
    }
  });
}

function addCouponListeners() {
  toggleCouponBox();
  addCodeRedemptionListeners();
  addRemoveCouponsListener();
  addVoucherListeners();
}

export { addCouponListeners, addRemoveCouponsListener };
